import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Chip, } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { mapStatusCodeToLabel } from 'src/utils/claim';

const useStyles = makeStyles((theme) => ({

    disposition: {
        marginLeft: theme.spacing(4),
        fontWeight: 600,
    },
    inReviewDisposition: {
        color: '#fa7306',
        backgroundColor: '#fabb3780',
    },
    openClaimDisposition: {
        color: '#007913',
        backgroundColor: '#D4F9DC'
    },
    approvedDisposition: {
        color: '#007913',
        backgroundColor: '#D4F9DC'
    },
    DeniedDisposition: {
        color: '#FF004E',
        backgroundColor: 'rgb(237 112 86 / 29%)',
    },
}));

function Disposition({ claimStatus, disposition, showStatus }) {
    const classes = useStyles();

    const getDispositionClass = (disposition, claimStatus) => {
        switch (disposition) {
            case 'In Review':
                return classes.inReviewDisposition;
            case 'Approved':
                return classes.approvedDisposition;
            case 'Denied':
                return classes.DeniedDisposition;
        }
    }

    const getDispositionLabel = (disposition, claimStatus, showStatus) => {
        if (!showStatus) { return disposition; }
        return disposition ? `${mapStatusCodeToLabel(claimStatus)} - ${disposition}` : mapStatusCodeToLabel(claimStatus);
    }

    return ((disposition || showStatus) && <Chip className={clsx(classes.disposition, getDispositionClass(disposition, claimStatus))}
        label={getDispositionLabel(disposition, claimStatus, showStatus)} />
    );
}

Disposition.propTypes = {

    claimStatus: PropTypes.string,
    disposition: PropTypes.string,
    showStatus: PropTypes.bool,
}

Disposition.defaultProps = {
    showStatus: false,
};
export default Disposition;
